import { isOnboardingBridgeTaskId } from './onboardingTaskBridge';
import { isMilestoneBridgeId } from './milestoneSchedule';

export type GanttTaskIdKind = 'onboarding' | 'milestone' | 'projectTask';

export function describeGanttTaskId(id: string): GanttTaskIdKind {
  if (isOnboardingBridgeTaskId(id)) return 'onboarding';
  if (isMilestoneBridgeId(id)) return 'milestone';
  return 'projectTask';
}

/** Readable label for console / UI (e.g. `[onboarding] onboarding-task:abc…`). */
export function formatGanttTaskIdForLog(id: string): string {
  const kind = describeGanttTaskId(id);
  const short = id.length > 40 ? `${id.slice(0, 36)}…` : id;
  return `[${kind}] ${short}`;
}
